import * as React from 'react';
import { Rater, RaterLevel } from './models';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faTimes } from '@fortawesome/free-solid-svg-icons';
import { css, SerializedStyles } from '@emotion/core';
import { COLORS } from '../../../globalStyle/colors';
import { Str } from '../../../localization/translationKeys';
import LocalInput from '../../../localization/LocalInput';
import { INPUT } from '../../../forms/styles/input';
import { SELECT } from '../../../forms/styles/select';
import * as R from 'ramda';
import LocalDropdownOption from '../../../localization/LocalDropdownOption';
import { Language } from '../../../localization/models';
import { FormikValues } from 'formik';
import LocalDiv from '../../../localization/LocalDiv';
import LocalSelect from '../../../localization/LocalSelect';


const styles = {
  actionIcon: css`
    font-size: 18px;
    color: ${COLORS.ICON_GREY};
    cursor: pointer;
  `,
  submitBtn: css`
    color: transparent;
    background-color: transparent;
    border: 0 none;
    padding: 0;
  `,
  disabledSaveIcon: css`
    color: ${COLORS.ICON_GREY};
    cursor: default;
  `,
  saveIcon: css`
    font-size: 22px;
    color: ${COLORS.GREEN};
  `,
  trashIcon: css`
    font-size: 22px;
  `,
  input: css`
    margin: 4px;
    padding-left: 12px;
    font-size: 12px;
  `,
  errorInput: css`
    border-color: ${COLORS.RED};
  `,
  dropdown: css`
    font-size: 12px;
  `,
};

type Props = {
  className?: string;
  rater: Rater;
  showNames: boolean;
  approval: boolean;
  inviteStatus: React.ReactNode;
  approvalElements: React.ReactNode;
  setRater: (rater?: Rater) => void;
  cancelSetRater: () => void;
  raterLevels?: RaterLevel[];
  projectLanguages?: Language[];
  formValues: FormikValues;
  iconStyle?: SerializedStyles;
  disableSubmitBtn: boolean;
  emailFieldError: boolean;
}


const renderLevels = (levels: RaterLevel[]) => R.map(
  level => (
    <LocalDropdownOption
      key={level.surveyLevelId}
      value={level.surveyLevelId}
      labelKey={''}
      labelText={level.fullName}
    />),
  levels,
);


const renderLanguages = (languages: Language[]) => R.map(
  lang => (
    <LocalDropdownOption
      key={lang.languageId}
      value={lang.languageId}
      labelKey={''}
      labelText={lang.nativeName}
    />
  ),
  languages,
);


const RaterEditableTableRow: React.FC<Props> = props => (
  <tr className={props.className} key={props.rater.raterId}>
    <td>
      {
        props.showNames && (
          <LocalInput
            name='firstName'
            type='text'
            value={props.formValues.firstName}
            css={[INPUT(), styles.input]}
            placeholderTranslation={Str.FirstName}
          />
        )
      }
      {
        props.showNames && (
          <LocalInput
            name='lastName'
            type='text'
            value={props.formValues.lastName}
            css={[INPUT(), styles.input]}
            placeholderTranslation={Str.LastName}
          />
        )
      }
      <LocalInput
        name='email'
        type='text'
        value={props.formValues.email}
        css={[INPUT(), styles.input, props.emailFieldError && styles.errorInput]}
        placeholderTranslation={Str.Email}
      />
    </td>
    {
      !!props.raterLevels && (
        <td>
          <LocalSelect
            css={[SELECT, styles.dropdown]}
            name='levelId'
            value={props.formValues.levelId}
            dir='auto'
          >
            {renderLevels(props.raterLevels)}
          </LocalSelect>
        </td>
      )
    }
    {
      !!props.projectLanguages && (
        <td>
          <LocalSelect
            css={[SELECT, styles.dropdown]}
            name='languageId'
            value={props.formValues.languageId}
            dir='auto'
          >
            {renderLanguages(props.projectLanguages)}
          </LocalSelect>
        </td>
      )
    }
    <td>
      {props.inviteStatus}
    </td>
    {props.approval && props.approvalElements}
    <td>
      <button css={styles.submitBtn} type='submit' disabled={props.disableSubmitBtn}>
        <FontAwesomeIcon
          icon={faSave}
          css={[styles.actionIcon, styles.saveIcon, props.disableSubmitBtn && styles.disabledSaveIcon]}
        />
      </button>
    </td>
    <td>
      <LocalDiv>
        <FontAwesomeIcon
          icon={faTimes}
          css={[styles.actionIcon, styles.trashIcon]}
          onClick={props.cancelSetRater}
        />
      </LocalDiv>
    </td>
  </tr>
);


export default RaterEditableTableRow;
